import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import { useAuthStore } from '@/stores/authStore';

// Pages
import { Login } from '@/pages/Auth/Login';
import { UnifiedDashboard } from '@/pages/Dashboard/UnifiedDashboard';

// Event SuperAdmin Pages
import EventSuperAdminIndex from '@/pages/EventSuperAdmin/index';
import EventTenantDetail from '@/pages/EventSuperAdmin/tenantDetail';
import EventSupport from '@/pages/EventSuperAdmin/Support';
import EventAnnouncements from '@/pages/EventSuperAdmin/Announcements';
import EventReports from '@/pages/EventSuperAdmin/Reports';
import EventSettings from '@/pages/EventSuperAdmin/Settings';
import EventAuditLogs from '@/pages/EventSuperAdmin/AuditLogs';
import EventNotifications from '@/pages/EventSuperAdmin/Notifications';
import GlobalProblemStatementsView from '@/pages/EventSuperAdmin/GlobalProblemStatements';
import SthitihMentorsView from '@/pages/EventSuperAdmin/SthitihMentors';

// Task SuperAdmin Pages
import TaskSuperAdminDashboard from '@/pages/TaskSuperAdmin/SuperAdminDashboard';

const App: React.FC = () => {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Login */}
        <Route path="/login" element={<Login />} />

        {/* Unified Portal Home */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UnifiedDashboard />
            </ProtectedRoute>
          }
        />

        {/* Event Management SuperAdmin Routes */}
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <EventSuperAdminIndex />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/tenants/:id"
          element={
            <ProtectedRoute>
              <EventTenantDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/global-ps"
          element={
            <ProtectedRoute>
              <GlobalProblemStatementsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/sthitih-mentors"
          element={
            <ProtectedRoute>
              <SthitihMentorsView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/support"
          element={
            <ProtectedRoute>
              <EventSupport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/announcements"
          element={
            <ProtectedRoute>
              <EventAnnouncements />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/reports"
          element={
            <ProtectedRoute>
              <EventReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/settings"
          element={
            <ProtectedRoute>
              <EventSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <EventSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/audit-logs"
          element={
            <ProtectedRoute>
              <EventAuditLogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/notifications"
          element={
            <ProtectedRoute>
              <EventNotifications />
            </ProtectedRoute>
          }
        />

        {/* Task Management SuperAdmin Routes */}
        <Route
          path="/tasks"
          element={
            <ProtectedRoute>
              <TaskSuperAdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Fallback Redirects */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
